



import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class DashboardComponent extends Vue {
    private mounted() {
      // @ts-ignore
      this.$Amplify.Auth.signOut();
      // @ts-ignore
      this.$router.push('/login');
    }
}
